import { getLastDayOfNextMonth, getLatestDate } from '@fora-monorepo/date-utils';

/** Get date picker range minimum for parameter start date */
export const getParameterStartDateMin = (
  monthlyReportingReleaseDate: string,
  employmentStartDate: string,
  fokParameterValidity?: { validFrom: string }
) => {
  const datesToCompare = [monthlyReportingReleaseDate, employmentStartDate];
  if (fokParameterValidity?.validFrom) {
    datesToCompare.push(fokParameterValidity.validFrom);
  }
  // Start of monthly reporting, minimun valid parameter date or start date of employment
  return getLatestDate(datesToCompare);
};

/** Get date picker range minimum for parameter end date */
export const getParameterEndDateMin = (
  fokParameterValidity?: { validFrom: string },
  parameterStartDate?: string,
  addEmploymentStartDate?: string
) => {
  const lastDayOfNextMonth = getLastDayOfNextMonth();
  const datesToCompare = [lastDayOfNextMonth];
  if (parameterStartDate) {
    datesToCompare.push(parameterStartDate);
  }
  if (addEmploymentStartDate) {
    datesToCompare.push(addEmploymentStartDate);
  }
  if (fokParameterValidity?.validFrom) {
    datesToCompare.push(fokParameterValidity.validFrom);
  }
  return getLatestDate(datesToCompare);
};
